import React, { useEffect, useState } from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import "./styles.css";
import './i18n'
import Sidebar from "./Components/Sidebar";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuthContext } from "./hooks/useAuthContext";
import Flashes from "./Routes/Flashes";
import Settings from "./Routes/Settings";
import Support from "./Routes/Support";
// import Home from "./Routes/Dashboard.js";
import History from "./Routes/History";
// import { MdOutlineToggleOff, MdOutlineToggleOn } from "react-icons/md";
import ProductUpdate from "./Routes/Product_Updates";
import Signup from "./Routes/Signup";
import Login from "./Routes/Login";
import ImageGeneration from "./Routes/Imagegeneration.js";
import VerifyEmail from "./Routes/Verify-Email";
import ResetPassword from "./Routes/Reset-Password";
import FetchForms from "./Components/FetchForms.js";
import Dashboard from "./Routes/Dashboard.js";
 import Success from "./Routes/success";
import CheckLogin from "./Routes/check";
// import EmailTemplate from "./Routes/Email-template";
import PageNotFound from "./Routes/PageNotFound";
import TTS from "./Routes/TTS";
import DynamicFormGenerator from "./Routes/Dynamic.js";
import CustomFlash from "./Components/CustomFlash.js";
import FormBuilder from "./Routes/FormBuilder.js";
import FormCreate from "./Routes/FormCreate.js";
import FormEdit from "./Routes/FormEdit.js";
import FormResponses from "./Routes/FormResponses.js";
import PublicFormPage from "./Routes/PublicFormPage.js";
import ApprovalAction from "./Routes/ApprovalAction.js";
import FormBuilderSettings from "./Routes/FormBuilderSettings.js";
import FormInsights from "./Routes/FormInsights.js";
import WorkflowList from "./Routes/WorkflowList.js";
import WorkflowBuilder from "./Routes/WorkflowBuilder.js";
import WorkflowRuns from "./Routes/WorkflowRuns.js";
import RecipeLibrary from "./Routes/RecipeLibrary.js";
import IntegrationsPage from "./Routes/IntegrationsPage.js";
import PlansPage from "./Routes/PlansPage.js";
import BillingDashboard from "./Routes/BillingDashboard.js";
import { UpgradeModalProvider } from "./Components/UpgradeModal.js";
import UsageWarningBanner from "./Components/UsageWarningBanner.js";
import ByokNudgeBanner from "./Components/ByokNudgeBanner.js";
import PaymentAlertBanner from "./Components/PaymentAlertBanner.js";
import VerifyEmailBanner from "./Components/VerifyEmailBanner.js";
import SupportLauncher from "./Components/SupportLauncher.js";
import AgencyDashboard from "./Routes/AgencyDashboard.js"
import WorkspaceBranding from "./Routes/WorkspaceBranding.js"
import Redeem from "./Routes/Redeem.js"
// import FormBuilderDemo from "./Components/FormBuilderDemo.js";

// After login/signup, honor a ?next=<internal path> (e.g. from /redeem) instead of always
// dumping the user on the dashboard — otherwise AppSumo redeemers never get back to /redeem.
function AuthedRedirect() {
    const [params] = useSearchParams();
    const next = params.get("next");
    const safe = next && next.startsWith("/") && !next.startsWith("//") ? next : "/";
    return <Navigate to={safe} replace />;
}

function AppContent() {
   const location = useLocation();
   const isPublicForm = location.pathname.startsWith("/f/");
   // Approval links are opened from an email by someone who may have no account —
   // render the page standalone rather than inside the logged-in app shell.
   const isApproval = location.pathname.startsWith("/approvals/");
   // const isDemoPage = location.pathname === "/demo";

   if (isPublicForm) {
      return (
         <Routes>
            <Route path="/f/:formId" element={<PublicFormPage />}></Route>
         </Routes>
      );
   }

   if (isApproval) {
      return (
         <Routes>
            <Route path="/approvals/:approvalId" element={<ApprovalAction />}></Route>
         </Routes>
      );
   }

   // if (isDemoPage) {
   //    return (
   //       <div style={{ minHeight: "100vh", backgroundColor: "#f9fafb", padding: "40px 16px" }}>
   //          <FormBuilderDemo
   //             apiUrl={process.env.REACT_APP_API_URL || "http://localhost:4000"}
   //             signupUrl="/signup"
   //          />
   //       </div>
   //    );
   // }

   return <AppLayout />;
}

function AppLayout() {
   const { user } = useAuthContext()
   const [toggleOnnState, setOnToggle] = useState("none");
   const [toggleOffState, setOffToggle] = useState("");
   const [showBanner, setShowBanner] = useState(() => {
      return localStorage.getItem("hideFormBuilderBanner") !== "true";
   });

   const dismissBanner = () => {
      setShowBanner(false);
      localStorage.setItem("hideFormBuilderBanner", "true");
   };


useEffect(()=>{
   function onWindowMatch  () {
      if (localStorage.theme === "dark") {
         document.documentElement.classList.add("dark")
   setOnToggle("")
   setOffToggle("none")
      } else {
         document.documentElement.classList.remove("dark")
      }
   }

   onWindowMatch()
  
})
  
 
   function toggleTheme() {
      
      const themeSet = document.documentElement.classList.toggle(localStorage.getItem("theme"))
      if (themeSet) {
         localStorage.setItem("theme", "dark");
         setOffToggle("none")
         setOnToggle("")
   
      } else {
         localStorage.removeItem("theme", "");
         setOffToggle("")
         setOnToggle("none")
      
      }


   }

//check if token is expired or not



   return (

         <div>

         {user && showBanner && (
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-center py-2 px-4 text-sm font-medium relative font-Rajdhani">
               <a href="/form-builder" className="text-white no-underline hover:underline">
                  New: AI Form Builder is here — Create beautiful forms in seconds with AI
               </a>
               <button
                  onClick={dismissBanner}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-transparent border-none cursor-pointer text-lg leading-none p-1"
                  aria-label="Dismiss banner"
               >
                  &#10005;
               </button>
            </div>
         )}

         <div className="min-h-screen md:flex bg-gray-50 dark:bg-[#181d33] dark:text-white">
         <Sidebar />
            {/* <Sidebar2/> */}

            <div className="flex-1 min-w-0">
           
               {user ?
                  // <div className="flex justify-end mt-2 lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mx-auto">
                  
                  //    <MdOutlineToggleOff className=" " size={40} onClick={toggleTheme} style={{ display: toggleOffState}} />
                  //    <MdOutlineToggleOn size={40} onClick={toggleTheme} style={{ display:toggleOnnState}} />
                  // </div>

                  <div className="flex justify-end items-center gap-3 h-14 px-4 sm:px-6 border-b border-gray-200 dark:border-gray-800 bg-white/70 dark:bg-gray-900/40 backdrop-blur sticky top-0 z-20">
                    <input type="checkbox" name="light-switch" className="light-switch sr-only" />
                    <label className="relative cursor-pointer p-2 shadow-sm border-1 rounded" for="light-switch">
                        <svg className="dark:hidden"  width="16" height="16" xmlns="http://www.w3.org/2000/svg"  onClick={toggleTheme} style={{ display: toggleOffState}}>
                            <path className="fill-slate-700" d="M7 0h2v2H7zM12.88 1.637l1.414 1.415-1.415 1.413-1.413-1.414zM14 7h2v2h-2zM12.95 14.433l-1.414-1.413 1.413-1.415 1.415 1.414zM7 14h2v2H7zM2.98 14.364l-1.413-1.415 1.414-1.414 1.414 1.415zM0 7h2v2H0zM3.05 1.706 4.463 3.12 3.05 4.535 1.636 3.12z" />
                            <path className="fill-slate-700" d="M8 4C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Z" />
                        </svg>
                        <svg className="hidden dark:block"  width="16" height="16" xmlns="http://www.w3.org/2000/svg" onClick={toggleTheme} style={{ display:toggleOnnState}} >
                            <path className="fill-slate-200" d="M6.2 1C3.2 1.8 1 4.6 1 7.9 1 11.8 4.2 15 8.1 15c3.3 0 6-2.2 6.9-5.2C9.7 11.2 4.8 6.3 6.2 1Z" />
                            <path className="fill-slate-200" d="M12.5 5a.625.625 0 0 1-.625-.625 1.252 1.252 0 0 0-1.25-1.25.625.625 0 1 1 0-1.25 1.252 1.252 0 0 0 1.25-1.25.625.625 0 1 1 1.25 0c.001.69.56 1.249 1.25 1.25a.625.625 0 1 1 0 1.25c-.69.001-1.249.56-1.25 1.25A.625.625 0 0 1 12.5 5Z" />
                        </svg>
                        <span className="sr-only">Switch to light / dark version</span>
                    </label>
                </div>
                 
         
                  : null}
               <UpgradeModalProvider>
               {user ? <VerifyEmailBanner /> : null}
               {user ? <PaymentAlertBanner /> : null}
               {user ? <UsageWarningBanner /> : null}
               {user ? <ByokNudgeBanner /> : null}
               {user ? <SupportLauncher /> : null}
               <Routes>
                  <Route path="/" element={user ? <Dashboard /> : <Navigate to="/login" />}></Route>
                  
                  {/* <Route path="/dash" element={ <Dash />}></Route> */}
<Route path="/success" element={<CheckLogin/>}></Route>
                  {/* <Route path="/flashes" element={user ? <Flashes /> : <Navigate to="/login" />}></Route>

                  <Route path="/flashes/:flashName" element={user ? <FlashFormTemplates /> : <Navigate to="/login" />}></Route> */}
{/* <Route path="hacker" element={<EmailTemplate/>}></Route> */}
                  <Route path="/settings" element={<Settings /> }></Route>

                  <Route path="/support" element={ <Support /> }></Route>
                  <Route path="/history" element={ <History /> }></Route>
                  <Route path="/flashes" element={ <Flashes /> }></Route>
  
                  <Route path="/flashes/:flashName" element={ <FetchForms /> }></Route>
                  <Route path="/dynamic" element={<DynamicFormGenerator/>}></Route>
                  <Route path="/dynamic/:flashName" element={user ? <CustomFlash /> : <Navigate to="/login" />}></Route>
                  <Route path="/product-updates" element={ <ProductUpdate /> }></Route>
                  <Route path="/login" element={!user ? <Login /> : <AuthedRedirect />}></Route>
                  <Route path="/signup" element={!user ? <Signup /> : <AuthedRedirect />}></Route>
                  <Route path="/verify-email" element={<VerifyEmail />}></Route>
                  <Route path="/reset-password" element={<ResetPassword />}></Route>
                  <Route path="/text-to-speech" element={ <TTS/>}></Route>                

                  <Route path="/ai-image-generation" element={<ImageGeneration/>}></Route>
                  <Route path="/reset-user-password" element={<ResetPassword />}></Route>
               <Route path="/success" element={<Success />}></Route>
                  <Route path="/form-builder" element={user ? <FormBuilder /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/create" element={user ? <FormCreate /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/edit/:formId" element={user ? <FormEdit /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/responses" element={user ? <FormResponses /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/insights" element={user ? <FormInsights /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/workflows" element={user ? <WorkflowList /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/workflows/:workflowId" element={user ? <WorkflowBuilder /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/workflows/:workflowId/runs" element={user ? <WorkflowRuns /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/:formId/recipes" element={user ? <RecipeLibrary /> : <Navigate to="/login" />}></Route>
                  <Route path="/form-builder/settings" element={user ? <FormBuilderSettings /> : <Navigate to="/login" />}></Route>
                  <Route path="/settings/integrations" element={user ? <IntegrationsPage /> : <Navigate to="/login" />}></Route>
                  <Route path="/settings/plans" element={user ? <PlansPage /> : <Navigate to="/login" />}></Route>
                  <Route path="/settings/billing" element={user ? <BillingDashboard /> : <Navigate to="/login" />}></Route>
                  <Route path="/pricing" element={user ? <PlansPage /> : <Navigate to="/login" />}></Route>
                  <Route path="/agency" element={user ? <AgencyDashboard /> : <Navigate to="/login" />}></Route>
                  <Route path="/agency/workspaces/:workspaceId/branding" element={user ? <WorkspaceBranding /> : <Navigate to="/login" />}></Route>
                  {/* LTD redemption — public but requires login to actually redeem */}
                  <Route path="/redeem" element={<Redeem />}></Route>
                  <Route path="/appsumo" element={<Redeem />}></Route>
                  {/* Admin lives in the separate CFAI_ADMIN project, not in this customer app. */}

               <Route path="*" element={<PageNotFound />}></Route>

               </Routes>
               </UpgradeModalProvider>

            </div>
         </div>
         </div>

   );

}

function App() {
   return (
      <BrowserRouter>
         <AppContent />
      </BrowserRouter>
   );
}

export default App;

